import ReCAPTCHA from "react-google-recaptcha";

export const BotRecaptcha = (props: { onChange: () => void }) => {
  return (
    <ReCAPTCHA
      size="compact"
      onChange={props.onChange}
      sitekey={process.env.GATSBY_GOOGLE_RECAPTCHA_KEY as string}
    />
  );
};
export default BotRecaptcha;
